import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ThemeContext } from '../../../context/ThemeContext'; // Adjust path if needed

const CodesiosLogo = () => {
    const { theme, themes } = useContext(ThemeContext);
    const themeStyles = themes?.[theme];

    return (
        <motion.div
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            transition={{ type: 'spring', stiffness: 400, damping: 25 }}
            className="flex items-center"
        >
            <a
                href="https://www.codesios.com"
                target="_blank"
                rel="noopener noreferrer"
                className={`text-xl sm:text-2xl font-bold tracking-tight no-underline transition-opacity duration-200 opacity-90 hover:opacity-100 focus:outline-none focus:ring-0 flex items-center gap-1.5 ${themeStyles?.text || 'text-white'}`}
            >
                <span>Codesios</span>
            </a>
        </motion.div>
    );
};

export default CodesiosLogo;